import config from 'config';
import { useCallback } from 'react';

import { useFireOnFirstInView } from '../../hooks/useFireOnFirstInView';
import { GTM, GTMElements, GTMLocations } from '../../utils/analytics';
import SocialProof from '../SocialProof';

const socialProofStats = config.get('socialProofStats');

interface Props {
  link?: string;
  name?: string;
  webpSrc?: string;
  useWebp: boolean;
  jpgSrc: string;
}

const Banner = (props: Props) => {
  const { link, name, jpgSrc, webpSrc, useWebp } = props;

  // The banner is only rendered on the home page; banner_name lets a single CMS campaign be counted (DEV-2379).
  const fireSeen = useCallback(() => {
    GTM.elementSeen(GTMElements.HOME_MAIN_BANNER, GTMLocations.HOME_PAGE, { banner_name: name });
  }, [name]);

  const bannerRef = useFireOnFirstInView(fireSeen, !!jpgSrc);

  const onBannerClick = () => {
    GTM.elementClicked(GTMElements.HOME_MAIN_BANNER, GTMLocations.HOME_PAGE, { banner_name: name });
  };

  return (
    <div className="banner" ref={bannerRef}>
      {link ? (
        <a className="banner-image-link" rel="noopener noreferrer" target="_blank" href={link} onClick={onBannerClick}>
          <picture>
            {useWebp && <source type="image/webp" srcSet={webpSrc} />}
            <img className="banner-image" src={jpgSrc} alt={name} />
          </picture>

          {socialProofStats.enabled && (
            <div className="hp_social_proof-holder">
              <SocialProof lightTheme={true} />
            </div>
          )}
        </a>
      ) : (
        <div className="banner-image-link">
          <picture>
            {useWebp && <source type="image/webp" srcSet={webpSrc} />}
            <img className="banner-image" src={jpgSrc} alt={name} />
          </picture>

          {socialProofStats.enabled && (
            <div className="hp_social_proof-holder">
              <SocialProof lightTheme={true} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Banner;
